module.exports = __webpack_public_path__ + "static/media/45.4c74bb85.jpg";